import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function Influencer() {
  useEffect(() => {
      // Scroll to top when this page is mounted
      window.scrollTo(0, 0);
    }, []);
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const services = [
    {
      id: 1,
      title: "Influencer Campaign Strategy",
      img: "/InfluencerImages/one.png",
      desc1:
        "We craft data-driven influencer strategies tailored to your brand’s goals. From identifying the right creators to defining campaign narratives, we ensure every collaboration drives awareness, engagement, and measurable impact.",
    },
    {
      id: 2,
      title: "Content & Creative Direction",
      img: "/InfluencerImages/two.png",
      desc1:
        "Our team conceptualizes and guides content that connects. From ideation to final output, we ensure every piece aligns with your brand voice, resonates with audiences, and delivers powerful storytelling.",
    },
    {
      id: 3,
      title: "Full Campaign Execution",
      img: "/InfluencerImages/three.png",
      desc1:
        "From planning to publishing, we handle it all. Our end-to-end execution covers influencer outreach, content approvals, posting, and real-time monitoring to deliver seamless and effective campaigns.",
    },
    {
      id: 4,
      title: "LinkedIn, Twitter & Instagram Campaigns",
      img: "/InfluencerImages/fourth.png",
      desc1:
        "We design and manage platform-specific campaigns that spark conversations. Whether it’s thought leadership on LinkedIn influencers, trends on Twitter influencers, or music promotion, we know what works where.",
    },
    {
      id: 5,
      title: "Performance Analytics & Reporting",
      img: "/InfluencerImages/five.png",
      desc1:
        "Get clear, actionable insights with our performance tracking. We analyze engagement, reach, conversions, and ROI to help you understand what’s working and optimize future campaigns.",
    },
    {
      id: 6,
      title: "Twitter Trending & Seeding Campaigns",
      img: "/InfluencerImages/six.png",
      desc1:
        "We specialize in making moments trend. From hashtag campaigns to organic seeding, we connect your brand with the right voices to create authentic buzz and drive Twitter conversations at scale.",
    },
    {
      id: 7,
      title: "Website Development & Google Ads",
      img: "/InfluencerImages/seven.png",
      desc1:
        "Build your brand’s digital foundation. Our web development and Google Ads services help you attract, convert, and retain customers with responsive websites and performance-driven ad strategies.",
    },
    {
      id: 8,
      title: "Email and SMS Marketing",
      img: "/InfluencerImages/eight.png",
      desc1:
        "Stay top of mind with your audience. Our targeted email and SMS campaigns deliver the right message at the right time, driving engagement, loyalty, and measurable results.",
    },
  ];

  return (
    <div className="container py-5 mt-4">
      {/* Heading Motion */}
      <motion.h1
        className="fw-bold mb-5 text-center"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        Our Services
      </motion.h1>

      {/* Services Section */}
      {services.map((item, index) => (
        <motion.div
          key={item.id}
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }} // triggers when 30% visible
          className={`mb-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-4 ${
            index % 2 !== 0 ? "flex-md-row-reverse" : ""
          }`}
        >
          {/* IMAGE */}
          <motion.div
            className="col-12 col-md-6 d-flex justify-content-center"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <motion.img
              src={item.img}
              alt={item.title}
              style={{
                width: "100%",
                maxWidth: "450px",
                height: "260px",
                objectFit: "cover",
                borderRadius: "14px",
                transition: "all 0.4s ease",
              }}
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 10px 20px rgba(0,0,0,0.25)",
              }}
            />
          </motion.div>

          {/* TEXT */}
          <motion.div
            className="col-12 col-md-6"
            initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <h4 className="fw-bold mb-2">
              {item.id}. {item.title}
            </h4>
            <p className="text-muted">{item.desc1}</p>
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}
